import { useEffect } from "react";

export const useAutoSelectStore = ({
  stores = [],
  storeCodeKey = "StoreCode",
  storeNameKey = "StoreName",
  combinedKey = "Combined",
  onChange,
}) => {
  useEffect(() => {
    if (Array.isArray(stores) && stores.length === 1) {
      const store = stores[0];

      onChange({
        storeCode: store[storeCodeKey],
        storeName: store[combinedKey] || store[storeNameKey],
      });
    }
  }, [stores, onChange, storeCodeKey, storeNameKey, combinedKey]);
};
